export default {"src":"/_next/static/media/rollerderby.ee264993.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};